/**
 * deriveChecklistSteps — derives the onboarding checklist from OperatorState.
 *
 * Returns 4 ordered steps with completion status, plus summary metadata.
 * The active step is the first incomplete one.
 */

import {
  PreviewStatus,
  LiveStatus,
  IntegrationHealth,
  ActionRoute,
  MODE_SUPPORT,
} from './operatorState';

export const ChecklistStepId = Object.freeze({
  CHOOSE_EXPERIENCE: 'choose_experience',
  THEME_INTEGRATION: 'theme_integration',
  BUILD_PREVIEW: 'build_preview',
  GO_LIVE: 'go_live',
});

export function deriveChecklistSteps(operatorState) {
  const s = operatorState;
  const onboarding = s.onboarding || {};
  const modeSelected = onboarding.modeSelected === true;
  const integrationStepCompleted = onboarding.integrationStepCompleted === true;
  const previewBuilt = onboarding.previewBuilt === true;

  const steps = [
    {
      id: ChecklistStepId.CHOOSE_EXPERIENCE,
      messageKey: 'operator.checklist.choose_experience',
      ctaKey: 'operator.checklist.cta_continue',
      complete: modeSelected || (s.mode !== null && MODE_SUPPORT[s.mode]?.supported !== false),
      route: ActionRoute.WIZARD_EXPERIENCE,
    },
    {
      id: ChecklistStepId.THEME_INTEGRATION,
      messageKey: 'operator.checklist.theme_integration',
      ctaKey: 'operator.checklist.cta_continue',
      complete: integrationStepCompleted || s.integrationHealth !== IntegrationHealth.UNKNOWN,
      route: ActionRoute.WIZARD_THEME,
    },
    {
      id: ChecklistStepId.BUILD_PREVIEW,
      messageKey: 'operator.checklist.build_preview',
      ctaKey: 'operator.checklist.cta_build_preview',
      complete: previewBuilt || s.preview === PreviewStatus.READY,
      route: ActionRoute.WIZARD_BUILD,
    },
    {
      id: ChecklistStepId.GO_LIVE,
      messageKey: 'operator.checklist.go_live',
      ctaKey: 'operator.checklist.cta_publish_live',
      complete: s.live === LiveStatus.ACTIVE,
      route: ActionRoute.HOME_ACTIVATE,
    },
  ];

  const completedCount = steps.filter((st) => st.complete).length;
  const isSetupComplete = completedCount === steps.length;
  const activeStepIndex = steps.findIndex((st) => !st.complete);

  return { steps, completedCount, total: steps.length, isSetupComplete, activeStepIndex };
}
